var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecipeBadge = function SvgRecipeBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "61px",
    viewBox: "0 0 45 61",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "recipe_Group 4 Copy 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elenco-Piatti/Ricette/Ristoranti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "utente_loggato_men\\xF9",
    transform: "translate(-1216.000000, -2010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(1216.000000, 2010.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L45,0 L45,61 C30,51.1975519 22.5,46.2963278 22.5,46.2963278 C22.5,46.2963278 15,51.1975519 0,61 L0,0 Z",
    id: "Path-5-Copy-10",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.000084,36.856609 L8.000084,10.070555 C8.000084,8.93170729 8.921984,8 10.048844,8 L34.241684,8 C34.733084,8 35.135444,8.40621589 35.135444,8.90284346 L35.135444,34.1612371",
    id: "Stroke-16",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64726,34.1614069 L35.13578,34.1614069 L35.13578,38.9986443 C35.13578,39.3038368 34.89092,39.5513017 34.58894,39.5513017 L10.64726,39.5513017 C9.18524,39.5513017 8,38.3538774 8,36.8763043 L8,36.8368288 C8,35.3588311 9.18524,34.1614069 10.64726,34.1614069 Z",
    id: "Stroke-18",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.135612,
    y1: 36.856609,
    x2: 11.055752,
    y2: 36.856609,
    id: "Stroke-20",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.64726,
    y1: 34.1614069,
    x2: 10.64726,
    y2: 10.3368662,
    id: "Stroke-22",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.903424,12.092763 L18.660104,12.092763 C18.182144,12.092763 17.791544,11.6975833 17.791544,11.2149632 C17.791544,10.7319186 18.182144,10.3367389 18.660104,10.3367389 L25.903424,10.3367389 C26.381384,10.3367389 26.771984,10.7319186 26.771984,11.2149632 C26.771984,11.6975833 26.381384,12.092763 25.903424,12.092763 Z",
    id: "Stroke-24",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.791452,17.6091918 C25.699892,17.6091918 25.608332,17.6151343 25.514252,17.6270194 C24.985472,16.2194835 23.675072,15.2674018 22.202972,15.2674018 C20.730872,15.2674018 19.420472,16.2194835 18.892112,17.6270194 C18.798032,17.6151343 18.706052,17.6091918 18.614492,17.6091918 C17.146592,17.6091918 15.952112,18.8562788 15.952112,20.3886083 C15.952112,21.7727985 16.925672,22.9235313 18.194912,23.1340674 L18.194912,25.0721884 C18.194912,25.8298638 18.785432,26.4466158 19.511612,26.4466158 L24.894332,26.4466158 C25.620512,26.4466158 26.211032,25.8298638 26.211032,25.0721884 L26.211032,24.4499183 L26.211032,23.1340674 C27.480272,22.9235313 28.454252,21.7727985 28.454252,20.3886083 C28.454252,18.8562788 27.259772,17.6091918 25.791452,17.6091918",
    id: "Fill-26",
    fill: "#F5C05A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(18.176053, 23.844882)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-28",
    fill: "#F5C05A",
    points: "0.0189006667 0.358526908 2.52966067 0.358526908 8.03544067 0.358526908"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-30",
    stroke: "#F6F6F6",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0189006667 0.358526908 2.52966067 0.358526908 8.03544067 0.358526908"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(19.588995, 20.800223)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.0066174902,
    y1: 0.0567434596,
    x2: 1.14565749,
    y2: 3.36334928,
    id: "Fill-32",
    fill: "#F5C05A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0066174902,
    y1: 0.0567434596,
    x2: 1.14565749,
    y2: 3.36334928,
    id: "Stroke-34",
    stroke: "#F6F6F6",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(23.636053, 20.800223)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.17427867,
    y1: 0.0567434596,
    x2: 0.0356586667,
    y2: 3.36334928,
    id: "Fill-36",
    fill: "#F5C05A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.17427867,
    y1: 0.0567434596,
    x2: 0.0356586667,
    y2: 3.36334928,
    id: "Stroke-38",
    stroke: "#F6F6F6",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(21.956053, 20.200212)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.282192762,
    y1: 0.0846986352,
    x2: 0.282192762,
    y2: 3.96348734,
    id: "Fill-40",
    fill: "#F5C05A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.282192762,
    y1: 0.0846986352,
    x2: 0.282192762,
    y2: 3.96348734,
    id: "Stroke-42",
    stroke: "#F6F6F6",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 17.993144,
    y1: 29.762093,
    x2: 26.570384,
    y2: 29.762093,
    id: "Stroke-44",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.35323,
    y1: 31.2937434,
    x2: 25.21013,
    y2: 31.2937434,
    id: "Stroke-46",
    stroke: "#1D1D1B",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecipeBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recipeBadge.1cabf14c.svg";
export { ForwardRef as ReactComponent };